import { Module } from "vuex";
import { RefreshGridMode } from "@/models/leads/ContactForm";
import { CampaignsState } from "@/models/states/CampaignsState";
import { RootState } from "@/models/states/RootState";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const campaignsModule: Module<CampaignsState, RootState> = {
  namespaced: true,
  state: {
    graphsHiddenOnScroll: false,
    campaignsLoading: false,
    isMediaChannel: false,
    needToRefreshCampaignsGrid: RefreshGridMode.None,
    page: 1,
    searchValue: "",
    selectedCampaignStatus: null,
    showGraphs: true,
    sortDir: "",
    sortField: "",
    campaignEditViewModel: undefined,
    campaigns: {},
    campaignsCancelTokenSource: undefined,
    campaignsPageData: undefined,
    campaignsPayload: undefined,
    columnsFilters: undefined,
    createPhoneViewModel: undefined,
    selectedCampaign: undefined,
    campaignEditSelectedProjectsIds: [],
    campaignEditSelectedTagsIds: [],
    campaignsStatsByDate: [],
    campaignsWithStats: [],
    clients: [],
    columns: [],
    datePeriod: [],
    projects: [],
    selectedCampaignGridColumnsIds: [],
    selectedCampaignsIds: [],
    selectedChannelMetadataTypesIds: [],
    selectedClientsIds: [],
    selectedProjectsIds: [],
    tableSettings: [],
  },
  getters,
  mutations,
  actions,
};
export default campaignsModule;
